module.exports = __webpack_public_path__ + "img/photo-jb-tournier.ef934e9a.jpg";